/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_LicenseInputs */

const en_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License Type`)
};

const es_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de licencia`)
};

const fr_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de licence`)
};

const de_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lizenztyp`)
};

const ja_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライセンスの種類`)
};

const zh_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`许可证类型`)
};

const ar_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نوع الرخصة`)
};

const id_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis Lisensi`)
};

const it_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di Licenza`)
};

const ru_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип лицензии`)
};

const pt_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de Licença`)
};

const ko_field_license = /** @type {(inputs: Field_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이선스 유형`)
};

/**
* | output |
* | --- |
* | "License Type" |
*
* @param {Field_LicenseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_license = /** @type {((inputs?: Field_LicenseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_LicenseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_license(inputs)
	if (locale === "es") return es_field_license(inputs)
	if (locale === "fr") return fr_field_license(inputs)
	if (locale === "de") return de_field_license(inputs)
	if (locale === "ja") return ja_field_license(inputs)
	if (locale === "zh") return zh_field_license(inputs)
	if (locale === "ar") return ar_field_license(inputs)
	if (locale === "id") return id_field_license(inputs)
	if (locale === "it") return it_field_license(inputs)
	if (locale === "ru") return ru_field_license(inputs)
	if (locale === "pt") return pt_field_license(inputs)
	return ko_field_license(inputs)
});